import { render, staticRenderFns } from "./EditSessionModal.vue?vue&type=template&id=48af37cc"
import script from "./EditSessionModal.vue?vue&type=script&lang=js"
export * from "./EditSessionModal.vue?vue&type=script&lang=js"
import style0 from "./EditSessionModal.vue?vue&type=style&index=0&id=48af37cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports